import React from 'react';

const AdSlot = ({ label }) => (
    <div className="w-full bg-white/50 border border-slate-200 rounded-2xl py-6 px-2 flex flex-col items-center justify-center my-6 min-h-[120px] backdrop-blur-sm shadow-inner">
        <span className="text-[10px] text-slate-400 font-bold uppercase mb-2 tracking-widest">{label}</span>
        <div className="text-slate-300 italic text-sm font-light text-center">AdSense Native Slot</div>
    </div>
);

export default AdSlot;
